// src/stats/ChartCard.js
import React from "react";
import { Card } from "react-bootstrap";

export default function ChartCard({ title, subtitle, children, actions, className = "" }) {
    return (
        <Card className={`border-0 shadow-sm h-100 ${className}`} style={{ borderRadius: '16px' }}>
            <Card.Header className="bg-white border-0 pt-4 d-flex justify-content-between align-items-center">
                <div>
                    <h6 className="mb-1 fw-semibold">{title}</h6>
                    {subtitle && <small className="text-muted">{subtitle}</small>}
                </div>
                {actions && <div>{actions}</div>}
            </Card.Header>
            <Card.Body className="p-3">
                {children}
            </Card.Body>
        </Card>
    );
}